// extracted by mini-css-extract-plugin
export default {"receiptWrapper":"Receipt_receiptWrapper__thypd","inner":"Receipt_inner__J2v+N","icon":"Receipt_icon__TJ+5-"};